// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1L4zl","header":"ReportDetails_header__2wBI8","title":"ReportDetails_title__TLHIq","left":"ReportDetails_left__3bWYr"};